import React from "react";
import "./Card.css";
import { useNavigate } from "react-router-dom";

import WCRInspect from "../../img/WCRInspect.png";
import dashboard from "../../img/dashboard.png";
import insertData from "../../img/insertData.png";
import cls from "../../img/cls.png";
import Railpariksha from "../../img/rp.png";
import cms from "../../img/CMS.png";
import blockDashBoard from "../../img/blockDashBoard.png";
import stationMapping from "../../img/stationMapping.png";

import {
  MdDashboard,
  MdOutlineInsertChart,
  MdOpenInNew,
  MdTrain,
  MdLocationOn,
  MdStorefront,
  MdEngineering,
} from "react-icons/md";

import { FaClipboardList, FaPenToSquare } from "react-icons/fa6";
import { GiCoalWagon } from "react-icons/gi";
import { LuTrainTrack } from "react-icons/lu";
import { PiExam } from "react-icons/pi";
import { FcInspection } from "react-icons/fc";
import { TbReportSearch } from "react-icons/tb";

const cardConfig = {
  DashBoard: {
    // image: dashboard,
    color: "#2196f3",
    icon: <MdDashboard />,
    description: "Monitor railway operations, performance and key activities.",
    path: "/DashBoard",
  },

  "Block DashBoard": {
    // image: blockDashBoard,
    color: "#e85d6a",
    icon: <MdTrain />,
    description: "View block-wise train operations and railway information.",
    path: "/BlockDashBoard",
  },

  "CMS Dashboard": {
    // image: cms,
    color: "#20b8c0",
    icon: <MdEngineering />,
    description: "Manage and monitor CMS related railway operations.",
    path: "/CMS",
  },

  "Station Map": {
    // image: stationMapping,
    color: "#e89a68",
    icon: <LuTrainTrack />,
    description: "Explore station information and railway network locations.",
    path: "/StationMap",
  },

  "Clearance and Supply": {
    // image: cls,
    color: "#a85dcc",
    icon: <GiCoalWagon />,
    description: "Monitor clearance, supply and material movement.",
    path: "/ClearanceAndSupply",
  },

  Store: {
    image: null,
    color: "#e62e6b",
    icon: <FaClipboardList />,
    description: "Access store information, materials and inventory data.",
    path: "/Store",
  },
  "Dynamic Report": {
    image: null,
    color: "#a5a20c",
    icon: <TbReportSearch />,
    description: "Access store information, materials and inventory data.",
    path: "/DynamicReport",
  },

  InsertData: {
    // image: insertData,
    color: "#4caf70",
    icon: <MdOutlineInsertChart />,
    description: "Insert, manage and update railway operational data.",
    path: "/InsertData",
  },

  WCR_Inspect: {
    image: WCRInspect,
    color: "#4a9fbe",
    icon: <FcInspection />,
    description: "Access WCR inspection tools and inspection information.",
    external: "http://89.116.34.79:5040",
  },

  "Rail-Pariksha": {
    image: Railpariksha,
    color: "#e58a32",
    icon: <PiExam />,
    description: "Online railway examination and preparation platform.",
    external: "http://89.116.34.79:5650",
  },
};

const Cards = ({ title, TextData }) => {
  const navigate = useNavigate();

  const config = cardConfig[title] || {
    image: null,
    color: "#607d8b",
    icon: <MdDashboard />,
    description: TextData || "Open this application.",
    path: null,
  };

  const description = TextData || config.description;

  const handleClick = () => {
    if (config.path) {
      navigate(config.path);
    }
  };

  const isExternal = Boolean(config.external);

  const cardContent = (
    <div
      className="rail-card"
      style={{
        "--accent": config.color,
      }}
      onClick={!isExternal ? handleClick : undefined}
    >
      {/* IMAGE SECTION */}
      <div
        className={`rail-card-image ${!config.image ? "no-image" : ""}`}
        style={
          config.image
            ? {
                backgroundImage: `url(${config.image})`,
              }
            : {}
        }
      >
        {/* Image dark overlay */}
        <div className="rail-card-overlay" />

        {/* Top badge */}
        <div className=" ">
          <div className="row d-flex justify-content-end ">
            <div className="rail-card-badge border">
              <span>{config.icon}</span>
              {/* <span>
            {title === "WCR_Inspect"
            ? "WCR Inspect"
            : title === "Rail-Pariksha"
            ? "Rail-Pariksha"
            : "RAIL SETU"}
            </span> */}
            </div>
          </div>
        </div>

        {/* Main title */}
        <div className="rail-card-image-content">
          <div className="rail-card-main-icon">{config.icon}</div>

          <h3>{title}</h3>
        </div>
      </div>

      {/* CONTENT */}
      <div className="rail-card-content">
        <div className="rail-card-heading">
          <div>
            <span className="rail-card-category">
              {isExternal ? "EXTERNAL APPLICATION" : "RAILWAY SYSTEM"}
            </span>

            <h4 className="text-left">{title}</h4>
          </div>

          <div className="rail-card-icon">{config.icon}</div>
        </div>

        <p className="align-left">{description}</p>

        {/* Action */}
        <div className="rail-card-action">
          <span>{isExternal ? "Open Application" : "Open Dashboard"}</span>

          <MdOpenInNew />
        </div>
      </div>
    </div>
  );

  if (isExternal) {
    return (
      <div className="rail-card-wrapper">
        <a
          href={config.external}
          target="_blank"
          rel="noopener noreferrer"
          className="rail-card-link"
        >
          {cardContent}
        </a>
      </div>
    );
  }

  return <div className="rail-card-wrapper">{cardContent}</div>;
};

export default Cards;
